// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"57795238","453":"9ce9b81a","663":"54693e19","907":"e96143db","913":"71723467"}[chunkId] + ".chunk.js";
};